(function () {
  'use strict';

  angular.module('eclipseApp.login').config(['$stateProvider', function ($stateProvider) {
    $stateProvider
      .state('login', {
        url: '/login',
        parent: 'app',
        title: 'login',
        views: {
          content: {
            template: '',
          }
        }
      }).state('signin', {
      url: '/signin?sessionExpired',
      parent: 'app',
      title: 'login',
      controllerAs: '$ctrl',
      resolve: {
        isLoggedIn: ['$rootScope', '$state', '$timeout', '$q', function ($rootScope, $state, $timeout, $q) {
          if ($rootScope.ruiMethods.user.is.loggedIn()) {
            $timeout(function () {
              if ($state.current && $state.current.name === 'myAccount.overview') {
                $state.reload('myAccount.overview');
              } else {
                $state.go('myAccount.overview');
              }
            });
            return $q.defer().promise;
          } else {
            return $q.when(true);
          }
        }]
      },
      views: {
        content: {
          templateUrl: 'modules/user/views/overview-loading.html',
          controller: 'signinController'
        }
      }
    });
  }]);

})();
